import React, { forwardRef, useState } from 'react';
import EmailContent from './EmailContent';
import { fontFamily, width } from '@mui/system';
import candado from '../../images/candado.svg'
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import useEmailValidation from '../hooks/useEmailValidation';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import WhmcsApi from '../../services/WhmcsApi'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next';

const RecoverPassword = forwardRef(({ setOpen, setSendMail, ...props }, ref) =>{
    
    const { email, emailError, handleEmailChange } = useEmailValidation();
    const handleOpen = () => setOpen(false);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '80%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        borderColor: 'white',
        boxShadow: 24,
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent:'center',
        alignItems: 'center',
        maxWidth: 600
      };

      const handleRecoverPassword = (event) => {
        event.preventDefault();
        setLoading(true)
        const fetchRecoverPass = async () => {
            try {
              const whmcsApi = new WhmcsApi(); // Crear instancia de WhmcsApi
              const response = await whmcsApi.request('resetPassword', {
                email: email,
              });
              if (response.result == 'error') {
                setOpen(false)
                Swal.fire({
                    title: 'Error!',
                    text: response.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                  })
              } else {
                if (response.result == 'success') {
                    setSendMail(true)
                }
              }
            } catch (error) {
                setOpen(false)
                Swal.fire({
                    title: 'Error!',
                    text: error,
                    icon: 'error',
                    confirmButtonText: 'OK'
                  })
                setLoading(false);
              console.error('Failed to fetch recover pass form:', error);
            } finally {
                setLoading(false);
            }
          };
      
          fetchRecoverPass();
      };

    return (
        <Box sx={style} ref={ref} {...props}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{fontFamily:'patua one', textAlign:'center'}}>
              {t("recoverPass.title")}
            </Typography>
            <img src={candado} alt="Mostrar password" height="24px" width="30px"></img> 
            <Typography id="modal-modal-description" sx={{ mt: 2, textAlign:'center' }}>
              {t("recoverPass.description")}
            </Typography>
            <TextField
                margin="normal"
                fullWidth
                id="recoveremail"
                label={t("signUp.fields.email")}
                name="recoveremail"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => handleEmailChange(e.target.value)}
                error={!!emailError}
                helperText={emailError}
            />
            <Button
                onClick={handleRecoverPassword}
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, textTransform: 'none', fontFamily: 'Patua One, sans-serif', fontSize: '18px', }}
                disabled={loading}
                className="btn-green"
            >
                {loading ? <CircularProgress /> : t("recoverPass.recoverText")}
            </Button>
            <Link onClick={handleOpen} style={{ fontSize: '14px', cursor: 'pointer', color:'#0D6EFD'}} variant="body2">
                {t("recoverPass.returntoLogin")}
            </Link>
        </Box>
    )
})

export default RecoverPassword;